/**
 * TOPLAP Header Enhancements
 * - Menu sidebar drawer (same pattern as cart drawer)
 * - Cart sidebar drawer
 * - Search panel
 */
(function () {
  'use strict';

  /* ================================================================
     MENU SIDEBAR DRAWER
     ================================================================ */
  document.addEventListener('DOMContentLoaded', function () {

    var menuDrawer  = document.getElementById('tl-menu-drawer');
    var menuOverlay = document.getElementById('tl-menu-overlay');
    var menuClose   = document.getElementById('tl-menu-close');
    var hamburger   = document.getElementById('tl-hamburger');

    if (!menuDrawer || !menuOverlay) return;

    /* Move to <body> so fixed positioning works reliably */
    document.body.appendChild(menuOverlay);
    document.body.appendChild(menuDrawer);

    function openMenu() {
      if (menuDrawer.classList.contains('is-open')) return;
      menuDrawer.classList.add('is-open');
      menuOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      if (menuClose) menuClose.focus();
    }

    function closeMenu() {
      if (!menuDrawer.classList.contains('is-open')) return;
      menuDrawer.classList.remove('is-open');
      menuOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      if (hamburger) hamburger.focus();
    }

    /* Open via hamburger */
    if (hamburger) {
      hamburger.addEventListener('click', function () {
        if (menuDrawer.classList.contains('is-open')) {
          closeMenu();
        } else {
          openMenu();
        }
      });
    }

    /* Close triggers */
    menuOverlay.addEventListener('click', closeMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuDrawer.classList.contains('is-open')) {
        closeMenu();
      }
    });

    /* Sub-menu accordion toggles */
    menuDrawer.querySelectorAll('.tl-menu-drawer__toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var parent = btn.closest('.tl-menu-drawer__item--parent');
        var isOpen = parent.classList.contains('is-expanded');
        parent.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    /* Search input: move focus ring to parent for icon colour */
    document.querySelectorAll('.hd6.hd2 input[type="search"], .hd6.hd2 .search-input').forEach(function (input) {
      input.addEventListener('focus', function () {
        this.closest('[class*="search"]')?.classList.add('tl-search-active');
      });
      input.addEventListener('blur', function () {
        this.closest('[class*="search"]')?.classList.remove('tl-search-active');
      });
    });

  });

  /* ================================================================
     CART SIDEBAR DRAWER
     ================================================================ */
  document.addEventListener('DOMContentLoaded', function () {

    const cartBtn    = document.getElementById('tl-cart-btn');
    const cartDrawer = document.getElementById('tl-cart-drawer');
    const cartOverlay= document.getElementById('tl-cart-overlay');
    const cartClose  = document.getElementById('tl-cart-close');

    if (!cartBtn || !cartDrawer) return;

    /* Move drawer + overlay to <body> so backdrop-filter
       on the header ancestor doesn't break position:fixed */
    document.body.appendChild(cartOverlay);
    document.body.appendChild(cartDrawer);

    function getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }

    /* Open */
    function openCart() {
      var sbw = getScrollbarWidth();
      document.body.style.paddingRight = sbw + 'px';
      var fixedHeader = document.querySelector('.hd6.hd2 .header-inner');
      if (fixedHeader) fixedHeader.style.paddingRight = sbw + 'px';

      cartDrawer.classList.add('is-open');
      cartOverlay.classList.add('is-open');
      document.body.classList.add('tl-cart-is-open');
      cartBtn.setAttribute('aria-expanded', 'true');
      cartClose.focus();
    }

    /* Close */
    function closeCart() {
      cartDrawer.classList.remove('is-open');
      cartOverlay.classList.remove('is-open');
      document.body.classList.remove('tl-cart-is-open');
      document.body.style.paddingRight = '';
      var fixedHeader = document.querySelector('.hd6.hd2 .header-inner');
      if (fixedHeader) fixedHeader.style.paddingRight = '';
      cartBtn.setAttribute('aria-expanded', 'false');
      cartBtn.focus();
    }

    cartBtn.addEventListener('click', openCart);
    cartClose.addEventListener('click', closeCart);
    cartOverlay.addEventListener('click', closeCart);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        closeCart();
      }
    });

    /* Remove item via Shopify AJAX API */
    cartDrawer.addEventListener('click', function (e) {
      const removeBtn = e.target.closest('.tl-cart-item__remove');
      if (!removeBtn) return;

      const variantId = removeBtn.dataset.variant;
      if (!variantId) return;

      removeBtn.disabled = true;
      const cartItem = removeBtn.closest('.tl-cart-item');
      if (cartItem) cartItem.style.opacity = '.4';

      fetch('/cart/change.js', {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ id: variantId, quantity: 0 })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        refreshCartDrawer(data);
        /* If we're on the cart page, reload so Liquid re-renders */
        if (/\/cart\b/.test(window.location.pathname)) {
          location.reload();
        }
      })
      .catch(function () {
        if (cartItem) cartItem.style.opacity = '1';
        removeBtn.disabled = false;
      });
    });

    /* Refresh drawer contents after a change */
    function refreshCartDrawer(cartData) {
      var count    = cartData.item_count || 0;
      var countEl  = document.getElementById('tl-cart-count');
      var drawerCount = document.getElementById('tl-drawer-count');

      if (countEl) {
        countEl.textContent = count;
        countEl.classList.toggle('tl-cart-btn__badge--hidden', count === 0);
      }
      if (drawerCount) {
        drawerCount.textContent = count;
        drawerCount.classList.toggle('tl-cart-drawer__count--hidden', count === 0);
      }

      var body = document.getElementById('tl-cart-body');
      var checkout = document.getElementById('tl-cart-checkout');
      var subtotalEl = document.getElementById('tl-cart-subtotal');

      if (count === 0) {
        body.innerHTML =
          '<div class="tl-cart-empty" id="tl-cart-empty">' +
          '<svg class="tl-cart-empty__icon" width="72" height="72" viewBox="0 0 24 24" fill="none">' +
          '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '<path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          '<p class="tl-cart-empty__text">Your basket is currently empty.</p>' +
          '<a href="/collections/all" class="tl-cart-empty__cta">Browse Laptops</a>' +
          '</div>';
        if (checkout) {
          checkout.classList.add('tl-cart-drawer__checkout--disabled');
          checkout.setAttribute('aria-disabled', 'true');
          checkout.setAttribute('tabindex', '-1');
        }
        if (subtotalEl) subtotalEl.closest('.tl-cart-drawer__subtotal')?.remove();
      } else {
        var html = '<div class="tl-cart-items" id="tl-cart-items">';
        cartData.items.forEach(function (item) {
          var imgHtml = item.image
            ? '<img src="' + item.image + '" alt="" width="80" height="80" loading="lazy" class="tl-cart-item__img">'
            : '<div class="tl-cart-item__img-placeholder"><svg width="28" height="28" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" stroke-width="1.5"/></svg></div>';
          var price = (item.line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cartData.currency || 'AED' });
          var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
            ? '<span class="tl-cart-item__variant">' + item.variant_title + '</span>' : '';
          html +=
            '<div class="tl-cart-item" data-variant-id="' + item.variant_id + '">' +
            '<a href="' + item.url + '" class="tl-cart-item__img-wrap">' + imgHtml + '</a>' +
            '<div class="tl-cart-item__info">' +
            '<a href="' + item.url + '" class="tl-cart-item__name">' + item.product_title + '</a>' +
            variantHtml +
            '<div class="tl-cart-item__row">' +
            '<span class="tl-cart-item__qty">Qty: ' + item.quantity + '</span>' +
            '<span class="tl-cart-item__price">' + price + '</span>' +
            '</div></div>' +
            '<button type="button" class="tl-cart-item__remove" data-variant="' + item.variant_id + '" aria-label="Remove item">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>' +
            '</button></div>';
        });
        html += '</div>';
        body.innerHTML = html;

        if (checkout) {
          checkout.classList.remove('tl-cart-drawer__checkout--disabled');
          checkout.removeAttribute('aria-disabled');
          checkout.removeAttribute('tabindex');
        }
        if (subtotalEl) {
          var total = (cartData.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cartData.currency || 'AED' });
          subtotalEl.textContent = total;
        }
      }
    }

    /* Intercept theme's add-to-cart events to refresh + open drawer */
    document.addEventListener('cart:updated', function (e) {
      if (e.detail) { refreshCartDrawer(e.detail); }
      openCart();
    });
    document.addEventListener('added_to_cart', function (e) {
      if (e.detail) { refreshCartDrawer(e.detail); }
      openCart();
    });

    /* Expose helpers so other scripts (common.js) can call them */
    window.tlRefreshCartDrawer = refreshCartDrawer;
    window.tlOpenCart = openCart;

  });

})();

/* ================================================================
   HEADER SEARCH — click search bar or icon → open side modal
   ================================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    var searchbar  = document.getElementById('tl-hdr-searchbar');
    var input      = document.getElementById('tl-hdr-input');
    var tagsPanel  = document.getElementById('tl-hdr-tags');
    var searchIcon = document.getElementById('tl-search-icon');

    function openSearchModal(query) {
      if (typeof window.bmSearch !== 'undefined') {
        window.bmSearch.open(query || '');
      }
    }

    if (searchbar) {
      searchbar.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openSearchModal();
      });
    }

    if (input) {
      input.addEventListener('focus', function () {
        this.blur();
        openSearchModal();
      });
    }

    if (tagsPanel) {
      tagsPanel.setAttribute('hidden', '');
    }

    if (searchIcon) {
      searchIcon.addEventListener('click', function () {
        openSearchModal();
      });
    }

    window.tlOpenSearch = function (query) {
      openSearchModal(query);
    };

  });

})();
